// Écran S.I — fonctions communes (mêmes règles que le serveur,
// backend-myalfa controllers/siController.js, pour mettre l'écran à jour
// immédiatement avant la réponse).

export const ORDRE_STATUT = { arrivee: 0, sortie: 1, actif: 2, sorti: 3 };

export const aujourdhui = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};
export const fmtD = (iso) => (iso ? new Date(`${String(iso).slice(0, 10)}T00:00`).toLocaleDateString("fr-FR") : "—");
export const fmtTs = (ts) => {
  const d = new Date(ts);
  return `${d.toLocaleDateString("fr-FR")} à ${d.toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" })}`;
};
export const initiales = (n) =>
  (n || "?")
    .split(/[\s-]+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((x) => x[0])
    .join("")
    .toUpperCase();
export const joursAvant = (iso) =>
  iso ? Math.round((new Date(`${iso}T00:00`) - new Date(`${aujourdhui()}T00:00`)) / 86400000) : null;

// Éléments restant à traiter : à l'arrivée, accès à ouvrir + domaine et
// RustDesk à renseigner ; à la sortie, accès encore ouverts.
export function aFaire(statut, l, outils) {
  const acces = l.acces || [];
  if (statut === "arrivee") return outils.filter((t) => !acces.includes(t.cle)).length + (l.rustdesk ? 0 : 1) + (l.domaine ? 0 : 1);
  if (statut === "sortie") return outils.filter((t) => acces.includes(t.cle)).length;
  return 0;
}

// Une application a-t-elle un compte pour cette ligne ? (Domaine et RustDesk
// se déduisent des identifiants, les autres des cases d'accès.)
export const aUnCompte = (l, app) => (app.caseAcces ? (l.acces || []).includes(app.cle) : !!(l[app.cle] || "").trim());

export const trier = (a, b) => ORDRE_STATUT[a.statut] - ORDRE_STATUT[b.statut] || a.nomComplet.localeCompare(b.nomComplet, "fr");
